import styled from "styled-components";

import { smMedia } from "../../../utils/getMediaStyle";

import { HeaderText } from "./Text";

export default styled(HeaderText)`
  font-size: 60px;
  color: ${({ theme }) => theme.color.text.headline};
  ${smMedia`
    font-size:28px;
    line-height: 36px;
  `}
`;
